import type { OptionsByPathQuery } from '../../../graphql/query/options/OptionsByPath.generated';

export type PartnerNames = Record<string, string>;

type DataPartnerExtra = { exchange_account_partner_id?: number | string | null } | null | undefined;

export const mapDataPartnerNames = (options: OptionsByPathQuery['optionsByPath']): PartnerNames =>
  options.reduce<PartnerNames>((names, option) => {
    const partnerId = (option?.extra as DataPartnerExtra)?.exchange_account_partner_id;

    if (option && partnerId != null) {
      names[String(partnerId)] = option.name;
    }

    return names;
  }, {});
